<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Product Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate>
            <div v-if="loading == true">
              <div class="sk-spinner sk-spinner-pulse"></div>
              <p class="text-center" style="color: #CCC;">Please wait . . .</p>
            </div>

            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Produk">
                    <b-form-input id="name" type="text" v-model="productForm.name" required></b-form-input>
                    <b-form-invalid-feedback>Nama Produk harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="product_group" label="Group Produk">
                    <model-select
                      id="product_group"
                      :options="listProductGroup"
                      v-model="$v.productForm.product_group.$model"
                      :isError="$v.productForm.product_group.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      required
                    ></model-select>
                    <div
                      v-if="productForm.product_group === null"
                      class="invalid-feedback-custom"
                    >Group Produk harus di pilih.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="maximum_side_heap" label="Tumpukan Maksimal">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.productForm.maximum_side_heap.$model"
                      :state="!$v.productForm.maximum_side_heap.$invalid"
                      placeholder="Tumpukan Maksimal"
                    ></b-form-input>
                    <b-form-invalid-feedback>Tumpukan Maksimal harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="qty_box_each_line" label="Total Box Per-Baris">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.productForm.qty_box_each_line.$model"
                      :state="!$v.productForm.qty_box_each_line.$invalid"
                      placeholder="Total Box Per-Baris"
                    ></b-form-input>
                    <b-form-invalid-feedback>Total Box Per-Baris harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="qty_each_box" label="Jumlah Dalam 1 Box">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.productForm.qty_each_box.$model"
                      :state="!$v.productForm.qty_each_box.$invalid"
                      placeholder="Jumlah Dalam 1 Box"
                    ></b-form-input>
                    <b-form-invalid-feedback>Jumlah Dalam 1 Box harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Produk PO Indomaret">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.productForm.name_for_idm.$model"
                      :state="!$v.productForm.name_for_idm.$invalid"
                      placeholder="Nama Produk PO Indomaret"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Produk PO Indomaret harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="status" label="Status">
                    <model-select
                      id="status"
                      :options="listStatusProduct"
                      v-model="$v.productForm.status.$model"
                      :isError="$v.productForm.status.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      required
                    ></model-select>
                    <div
                      v-if="productForm.status === null"
                      class="invalid-feedback-custom"
                    >Status harus di pilih.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="editProduct"
                  :disabled="$v.productForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Setting Harga Jual" active>
            <global-table
              :table-data="pricingListing"
              :loading="loading"
              :per-page="10"
              :table-detail="tableDetail"
              :bordered="true"
              :hover="true"
              :striped="false"
              :id-modals="'pricingForm'"
              :row-edit="pricingForm"
              :redirect-detail="false"
              :show-add-button="true"
              :remove-button="false"
              :fields="fieldsPricing"
              addButton="Harga Produk"
              @editForm="editPricingForm"
              @resetForm="resetPricingForm"
              @removeForm="removePricingForm"
            ></global-table>

            <b-modal
              ref="myModalDetailRef"
              id="pricingForm"
              header-border-variant="no-border text-center"
              footer-border-variant="no-border"
              footer-bg-variant="light"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              size="lg"
            >
              <div slot="modal-header" class="text-center">
                <h3 class="text-center">Form Product Pricing</h3>
              </div>

              <b-form id="pricingForm" validated novalidate>
                <div v-if="!loadingSubmitModal">
                  <b-row>
                    <b-col sm="4" v-if="pricingForm.isEdit !== 1">
                      <b-form-group label-for="customer_group_id" label="Group Konsumen">
                        <model-select
                          id="customer_group_id"
                          :options="listCustomerGroup"
                          v-model="$v.pricingForm.customer_group_id.$model"
                          :isError="$v.pricingForm.customer_group_id.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="pricingForm.customer_group_id === null"
                          class="invalid-feedback-custom"
                        >Group konsumen harus di isi.</div>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4" v-if="pricingForm.isEdit !== 1">
                      <b-form-group label-for="pricing_unit_id" label="Harga Satuan">
                        <model-select
                          id="pricing_unit_id"
                          :options="listPricingUnit"
                          v-model="$v.pricingForm.pricing_unit_id.$model"
                          :isError="$v.pricingForm.pricing_unit_id.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="pricingForm.pricing_unit_id === null"
                          class="invalid-feedback-custom"
                        >Harga satuan harus di isi.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group label-for="price" label="Harga">
                        <b-form-input
                          id="price"
                          type="number"
                          v-model="$v.pricingForm.price.$model"
                          :state="!$v.pricingForm.price.$invalid"
                          placeholder="Harga"
                          min="0"
                          required
                        ></b-form-input>
                        <b-form-invalid-feedback>Harga harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group label-for="fee" label="Fee">
                        <b-form-input
                          id="fee"
                          type="number"
                          v-model="$v.pricingForm.fee.$model"
                          :state="!$v.pricingForm.fee.$invalid"
                          placeholder="Fee"
                          min="0"
                        ></b-form-input>
                        <b-form-invalid-feedback>Fee harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <div v-else>
                  <loading></loading>
                </div>
              </b-form>

              <div slot="modal-footer" class="float-right">
                <div v-if="!loadingSubmitModal">
                  <b-button type="button" size="sm" variant="danger" @click="cancelAddPricing">
                    <i class="fa fa-undo"></i> Back
                  </b-button>&nbsp;
                  <b-button
                    type="button"
                    size="sm"
                    variant="primary"
                    @click="submitAddPricing"
                    :disabled="$v.pricingForm.$invalid"
                  >
                    <i class="fa fa-save"></i> Save
                  </b-button>
                </div>
              </div>
            </b-modal>
        </b-tab>

        <b-tab title="Setting Harga Beli">
          <product-purchase-price
            :product-id="productId"
          >

          </product-purchase-price>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import ProductPurchasePrice from "./tabs/PurchasePrice";

export default {
  name: "product_detail",
  components: {
    globalTable,
    ModelSelect,
    loading,
    ProductPurchasePrice
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      removeButton: true,
      product: [],
      productId: null,
      pricingListing: [],
      listCustomerGroup: [],
      listPricingUnit: [],
      listProductGroup: [],
      fieldsPricing: [
        { key: "customer_group_name", label: "Grup Konsumen", sortable: true },
        { key: "pricing_unit_name", label: "Harga Satuan" },
        { key: "price", label: "Harga" },
        { key: "fee", label: "Fee" },
        { key: "action", class: "text-center width-100" }
      ],
      listStatusProduct: [
        { value: "1", text: "Available" },
        { value: "2", text: "Unavailable" }
      ],
      productForm: interfaces.product,
      pricingForm: interfaces.pricing,
      loading: true,
      loadingSubmitModal: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    productForm: {
      name: { required },
      product_group: { required },
      status: { required },
      name_for_idm: {},
      maximum_side_heap: {},
      qty_box_each_line: {},
      qty_each_box: {}
    },
    pricingForm: {
      customer_group_id: { required },
      pricing_unit_id: { required },
      price: { required },
      fee: { }
    }
  },
  computed: {
    customer_group() {
      let status_spkb = 0;
      for (let i of this.spkb) {
        status_spkb = parseInt(i.status_spkb);
      }
      return status_spkb;
    }
  },
  methods: {
    init: function(produk_id) {
      this.loading = true;
      this.productId = produk_id;
      this.getAllProductDetail(produk_id);
      this.getDropdown(produk_id);
    },
    getAllProductDetail(produk_id) {
      this.axios
        .get("web/product/detail/" + produk_id + "/")
        .then(response => {
          this.productForm = response.data.products;
          this.pricingListing = response.data.pricing_products;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown(produk_id) {
      let route = this.$route.path.split("/");
      this.axios
        .get("web/dropdown/dropdown-product-pricing/"+produk_id+"/")
        .then(response => {
          this.listCustomerGroup = response.data.customer_group;
          this.listPricingUnit = response.data.pricing_unit;
          this.listProductGroup = response.data.products_group;
        })
        .catch(error => {})
        .finally(() => {});
    },
    editProduct: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah produk ?")) {
        this.axios
          .put("web/product/change-detail/", this.productForm)
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Ubah Produk",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Change product");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    editPricingForm: function(data) {
      this.resetPricingForm();
      this.pricingForm = data;
      this.pricingForm.isEdit = 1;
    },
    removePricingForm: function(data) {
      console.log(data);
    },
    back: function() {
      this.$router.go(-1);
    },
    resetForm: function() {
      for (var a in interfaces.product) {
        interfaces.product[a] = null;
      }
      this.productForm = interfaces.product;
    },
    resetPricingForm: function() {
      for (var a in interfaces.pricing) {
        interfaces.pricing[a] = null;
      }
      this.pricingForm = interfaces.pricing;
    },
    cancelAddPricing: function() {
      this.$refs.myModalDetailRef.hide();
    },
    submitAddPricing: function(evt) {
      evt.preventDefault();
      let pricingProduct = this.pricingForm;
      pricingProduct.product_id = this.productForm.id;

      if (pricingProduct.isEdit !== 1) {
        if (confirm("Apakah anda ingin menambahkan harga produk ini ?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/product/add-pricing-product/", pricingProduct)
            .then(response => {
              let _detailData = response.data.data;
              this.showInfoNotification({
                title: "Tambah harga produk",
                message: response.data.message
              });
            })
            .catch(error => {
              this.expired(error, "Add pricing product");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAddPricing();
              let route = this.$route.path.split("/");
              this.init(route[4]);
            });
        }
      } else {
        if (confirm("Apakah anda ingin mengubah harga produk ini ?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/product/change-pricing-product/", pricingProduct)
            .then(response => {
              let _detailData = response.data.data;
              this.showInfoNotification({
                title: "Ubah harga produk",
                message: response.data.message
              });
            })
            .catch(error => {
              this.expired(error, "Change pricing product");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAddPricing();
              let route = this.$route.path.split("/");
              this.init(route[4]);
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>

<style>
</style>
